// constants
import { EVENTS, USER_STATUS } from './constants';

export interface IDataLayer {
  previous_page_url: string;
  previous_page_type: string;
  previous_page: string;
  user_login_status: USER_STATUS;
  pagetype: string;
  currency: string;
  pagename: string;
  page_url: string;
  channel: string;
  event?: EVENTS;
  bannername?: string;
  site_navigation?: string;
  site_subnavigation?: string;
  cutomer_id?: number;
  product_id?: string;
  sku?: string;
  price?: string;
  ui: string;
  category?: string;
  brand?: string;
  phone: string;
  userEmail: string;
  firstName: string;
  lastName: string;
  customerId: string;
  availableSizes?: string;
  eventName: string;
  productRating?: number;
  totalReviewCount?: number;
  AB: { [key: string]: string | number };
  email: string;
  analyticsSdkData: { [key: string]: string | number | boolean };
}

export enum TASK_TYPES {
  PAGE_LOAD,
  EVENT,
}

export type ITask =
  | {
      type: TASK_TYPES.PAGE_LOAD;
      data: Partial<IDataLayer>;
    }
  | {
      type: TASK_TYPES.EVENT;
      eventName: string;
      data: { [key: string]: string };
    };
